export default "__VITE_ASSET__BKhFtEik__"